import {
  PaginationFilterBy,
  PaginationOptions,
  PaginationSortBy,
} from "../interfaces";

function buildSortBy(sorts: PaginationSortBy[]): string {
  let sortBy = "";
  for (let i = 0; i < sorts.length; i++) {
    if (i > 0) {
      sortBy += ",";
    }
    const actualSort = sorts[i].order + "(" + sorts[i].field + ")";
    sortBy += actualSort;
  }
  return sortBy;
}

function buildFilterBy(filters: PaginationFilterBy[]): string {
  let filterBy = "";
  for (let i = 0; i < filters.length; i++) {
    if (i > 0) {
      filterBy += ",";
    }
    const actualSort = filters[i].value + "(" + filters[i].field + ")";
    filterBy += actualSort;
  }
  return filterBy;
}

export function buildPaginationQueryString(
  options: Partial<PaginationOptions>
) {
  let stringBuild = [];

  if (options.sort_by) {
    stringBuild.push(`sort_by=${buildSortBy(options.sort_by)}`);
  }

  if (options.limit) {
    stringBuild.push(`limit=${options.limit}`);
  }

  if (options.filter_by) {
    stringBuild.push(`filter_by=${buildFilterBy(options.filter_by)}`);
  }

  if (options.start_after) {
    stringBuild.push(`start_after=${options.start_after}`);
  }

  return stringBuild.join("&");
}
